import { faMapPin } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Whisper } from 'rsuite';

export default function updatePlaceType() {
    return (
        <div data-cy="historic-icon-updatePlaceType">
            <Whisper
                placement="right"
                trigger="hover"
                speaker={
                    <Tooltip>
                        <FormattedMessage id="history.updatePlaceType" />
                    </Tooltip>
                }>
                <FontAwesomeIcon icon={faMapPin} size="lg" style={{ color: '#2184da' }} />
            </Whisper>
        </div>
    );
}
